import i18next from 'i18next'

export default function localizeDate(date: Date): string {
  return new Intl.DateTimeFormat(i18next.language.split('-')[0], {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date)
}
